<template>
    <section class="chart-container">
        <!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters"  size="mini">
                <el-form-item label="统计维度" >
					<el-select v-model="dataType" placeholder="请选择统计维度"     @change="getDataList" >
						<el-option label="项目" value="project"></el-option>
						<el-option label="点位" value="device"></el-option>
                        <el-option label="功能区" value="area"></el-option>
					</el-select>
				</el-form-item>
                <el-form-item label="项目">
					<el-select v-model="filters.projectId"     @change="getDevices" style="width:250px" filterable>
						<el-option
							v-for="item in projects"
							:label="item.name"
							:value="item.projectId" :key="item.projectId">
						</el-option >
					</el-select>
				</el-form-item>
                <el-form-item label="点位名称"   v-if="dataType=='device'">
					<el-select v-model="filters.mn"   style="width:320px" filterable reserve-keyword>
						<el-option
							v-for="item in devices"
							:label="item.name"
							:value="item.mnCode" :key="item.mnCode">
						</el-option>
					</el-select>
				</el-form-item>
                <el-form-item label="设备编码"  v-if="type==0&&dataType=='device'">
					<el-select v-model="filters.mn"  style="width:320px" filterable reserve-keyword>
						<el-option
							v-for="item in devices"
							:label="item.mnCode"
							:value="item.mnCode" :key="item.mnCode">
						</el-option>
					</el-select>
				</el-form-item>
                <el-form-item label="功能区"   v-if="dataType=='area'">
					<el-select v-model="filters.functionalArea"   style="width:320px" filterable reserve-keyword>
						<el-option
							v-for="item in functionalAreaList"
							:label="item.name"
							:value="item.id" :key="item.id">
						</el-option>
					</el-select>
				</el-form-item>
                <el-form-item label="因子" >
					<el-select v-model="factor" placeholder="请选择数据类型"     @change="getDataList" >
						<el-option label="昼数据" value="n00004"></el-option>
						<el-option label="夜数据" value="n00005"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<my-button  @select-type="clickBtn" QueryButtonShow ></my-button>
				</el-form-item>
			</el-form>
		</el-col>

        <!-- 折线图 -->
        <el-col :span="24"   v-loading="listLoading" style="overflow: hidden;">
            <el-calendar v-model="calendarvalue" class="calendar_left">
                <template  slot="dateCell"  slot-scope="{date, data}" >
                    <div class="Userdate"   v-if="realDatas.get (data.day)!=undefined" @click="chooseDate(data.day)">
                        <div  class="ueds_iedn"  :style="'border:4px solid '+realDatas.get (data.day)">{{ data.day.split('-')[2]}}</div>
                    </div>
                    <div class="Userdate"   v-else @click="chooseDate(data.day)">
                        <div  class="ueds_iedn"  style="border:none">{{ data.day.split('-')[2]}}</div>
                    </div>
                </template>
            </el-calendar>
            <div  class="calendar_right">
                <div class="cal_date">{{ date }}</div>
                <div class="cal_day">{{ num }}</div>
                <div>
                    <div v-for=" item in levelList" style="display: flex;margin-left: 20px;align-items: center;margin-top: 20px;">
                        <div  class="uenf_l" :style="'border:4px solid '+item.color"></div>
                        <span :style="'color:'+item.color">{{item.remark}}({{item.level}},{{item.range}})</span>
                    </div>
                </div>
            </div>
        </el-col>

    </section>
</template>

<script>
    import {getProjects,getDevicesByProjectId,selectPollutionCalendar,getFunctionalAreaList} from '../../api/api';

    import {formatDateDay,formatDate} from '../../../static/fun.js';

    import myButton from '../../components/myButton/index.vue'

    export default {
    components: { myButton },
        data() {
            return {
                filters: {
                    mn: '',
                    projectId:'',
                    functionalArea:''
                },
                calendarvalue:'',
                projects:[],
                devices:[],
                realDatas:new Map(),
                listLoading:false,
                firstFlag:true,
                formHeight:0,
                factor:'n00004',
                dataType:'project',
                type:sessionStorage.getItem("type"),
                date:'',
                num:'',
                levelList:[],
                levelLd:[
                    {id:1,level:'一级',remark:'好',range:'Ld≤50.0dB',limit:50,color:'#00f'},
                    {id:2,level:'二级',remark:'较好',range:'Ld50.1~Ld55.0dB',limit:55,color:'#078010'},
                    {id:3,level:'三级',remark:'一般',range:'Ld55.1~Ld60.0dB',limit:60,color:'#ffc107'},
                    {id:4,level:'四级',remark:'较差',range:'Ld60.1~Ld65.0dB',limit:65,color:'#810378'},
                    {id:5,level:'五级',remark:'差',range:'Ld≥65.0dB',color:'red'}
                ],
                levelLn:[
                    {id:1,level:'一级',remark:'好',range:'Ld≤40.0dB',limit:40,color:'#00f'},
                    {id:2,level:'二级',remark:'较好',range:'Ld40.1~Ld45.0dB',limit:45,color:'#078010'},
                    {id:3,level:'三级',remark:'一般',range:'Ld45.1~Ld50.0dB',limit:50,color:'#ffc107'},
                    {id:4,level:'四级',remark:'较差',range:'Ld50.1~Ld55.0dB',limit:55,color:'#810378'},
                    {id:5,level:'五级',remark:'差',range:'Ld≥55.0dB',color:'red'}
                ],
                functionalAreaList:[]
            }
        },
        created(){
            this.$nextTick(() => {
                // 点击上个月
                let prevBtn = document.querySelector('.el-calendar__button-group .el-button-group>button:nth-child(1)');
                prevBtn.addEventListener('click', () => {
                    this.calendarvalue=formatDateDay(this.calendarvalue);
                    this.date=this.calendarvalue;
                    this.num=this.date.split('-')[2];
                    this.getDataList();
                })
                // 点击今天
                let currBtn = document.querySelector('.el-calendar__button-group .el-button-group>button:nth-child(2)');
                currBtn.addEventListener('click', () => {
                    this.calendarvalue=formatDateDay(this.calendarvalue);
                    this.date=this.calendarvalue;
                    this.num=this.date.split('-')[2];
                    this.getDataList();
                })
                // 点击下个月
                let nextBtn = document.querySelector('.el-calendar__button-group .el-button-group>button:nth-child(3)');
                nextBtn.addEventListener('click', () => {
                    this.calendarvalue=formatDateDay(this.calendarvalue);
                    this.date=this.calendarvalue;
                    this.num=this.date.split('-')[2];
                    this.getDataList();
                })
            })
        },
        methods: {
            clickBtn(type){
				if(type=="query"){
					this.getDataList();
				}
			},
            chooseDate(data){
                this.date=data;
                this.num=data.split('-')[2];
            },
            //查询项目信息
			getProjects() {
				this.listLoading = true;
				getProjects().then((res) => {
                    this.projects = res.data.data;
                    this.listLoading = false;
			        if(this.projects.length>0){
                         this.filters.projectId=this.projects[0].projectId;
						this.getDevices();
					}
				});
			},
            //获取趋势分析数据
            getDataList(){
                this.calendarvalue=formatDate(this.calendarvalue);
                var arr=this.calendarvalue.split('-');
                var starttime=arr[0]+"-"+arr[1];

                let para = {
                    projectId:this.filters.projectId,
                    functionalArea:this.filters.functionalArea,
                    mn: this.filters.mn,
                    date: starttime,
                    dataType:this.dataType
                };
                this.listLoading = true;
                //数据格式处理
				selectPollutionCalendar(para).then((res) => {
                    this.listLoading = false;
                    if(res.data.msg==true||res.data.msg=="true"){
                        var seriesData=[];
                        if(this.factor=="n00004"){
                            this.levelList=this.levelLd;
                            var seriesData=res.data.data.dayTimeValList;
                        }else{
                            this.levelList=this.levelLn;
                            var seriesData=res.data.data.nightValList;
                        }
                        var timeList=res.data.data.dateTimeList;
                        this.realDatas=new Map();
                        if(timeList==undefined){
                            return;
                        }
                        for (let index = 0; index < timeList.length; index++) {
                            const element = timeList[index];
                            var value=seriesData[index];
                            if(value=="0"){
                                continue;
                            }
                            var color="red";
                            //判断颜色
                            for (let j = 0; j < this.levelList.length; j++) {
                                var limit = this.levelList[j].limit;
                                if(value<=limit){
                                    color=this.levelList[j].color;
                                    break;
                                }
                            }
                            this.realDatas.set(element,color);
                        }
                    }else{
                        this.$message({
                            message: "查询出错,请重试",
                            type: 'warn'
                        })
                        return;
                    }
				});
            },
            //获取设备列表
			getDevices() {
                 if(this.filters.projectId.toString()==""){
                    return;
                }
                this.listLoading = true;
                let para = {
                    projectId: this.filters.projectId.toString()
                };
				getDevicesByProjectId(para).then((res) => {
                    this.listLoading = false;
                    
                    this.devices = res.data.data;
                    if(this.devices.length>0){
                        this.filters.mn=this.devices[0].mnCode;
                        if(this.firstFlag){
                            this.getDataList();
                            this.firstFlag=false;
                        }
					}

				});
            },
            getFunctionalAreaList(){
                getFunctionalAreaList({}).then((res) => {
                    this.functionalAreaList=res.data.data;
                    if(this.functionalAreaList.length>0){
                        this.filters.functionalArea=this.functionalAreaList[0].id;
                    }
				});
			},
        },
        mounted: function () {
            this.calendarvalue=new Date();
            this.calendarvalue=formatDateDay(this.calendarvalue);
            this.date=this.calendarvalue;
            this.num=this.calendarvalue.split('-')[2];
            this.getProjects();
            this.getFunctionalAreaList();
            this.levelList=this.levelLd;
        }
    }
</script>

<style scoped>
    .el-col-1{
        text-align: center;
    }
    .dataTab{
		margin: 10px;
		margin-top: 0;
		cursor: pointer;
		color: #409eff;
		background: #d9edf7;
	}
    .tabSelect{
		color: #fff;
		background: #409eff;
	}

    .calendar_left{
        width: 60%;
        margin-left: 5%;
        float:left;
    }
    .calendar_right{
        width: 20%;
        float:left;
        padding-bottom: 2%;
        margin-top: 6vh;
        background: #6cd3fb;
        margin-left: 3%;
    }

    .cal_date {
        color: #fff;
        font-size: 24px;
        padding-top: 10px;
        margin-left: 10px;
        font-weight: bold;
    }
    .cal_day {
        margin: 20px auto;
        width: 60%;
        height: 100px;
        background: #fb0;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        color: #fff;
        font-size: 40px;
        align-items: center;
        display: flex;
    }

    .uenf_l {
        width: 50px;
        height: 50px;
        background: #6cd3fb;
        border-radius: 50%;
        margin-right: 20px;
    }


    .Userdate {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        height: 100%;
    }
    .ueds_iedn{
        width: 50px;
        height: 50px;
        border-radius: 50%;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
    }
</style>



// WEBPACK FOOTER //
// NoiseCalendar.vue?6328e43f